import * as action_type from '../../../../Store/Constant'

export const resInitialProfileDataReducer = (data = {response: false, backend_data: null }, action) => {
    switch (action.type) {
        case action_type.SET_RES_INITIAL_PROFILE:
            return action.data;
        default:
            return data
    }
}
